import { images } from ".";

const partners = [
    images.sponsorInex,
    images.sponsorDataScience,
    images.sponsorGenexis,
    images.sponsorV7Idea,
    images.sponsorZeer,
    images.sponsorSari,
    images.sponsorTheHub,
    images.sponsorCrytal,
    images.sponsorLuckyCoding,
    images.sponsorWinner,
    images.sponsorTitan,
    images.sponsorSyscore
];

export default partners;